import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFormikContext } from "formik";
import { useRecoilValue } from "recoil";
import { FlexContext } from "../models/flexible/flex-context";
import { Article71Indication, Brand, Disease, Generic, Indication } from "../models/generated/graphql";
import { flexibleFormValuesState } from "../store/flexible";
import { castToArray, getAttributeValueDeep, getAttributeValuesDeep } from "../utils/agreement-utils";

export const useScopeFields = (_context: FlexContext) => {
	const { values } = useFormikContext();
	const mergedValues = useRecoilValue(flexibleFormValuesState);
	const actualValues = { ...mergedValues, ...(values as any) };
	const brands = getAttributeValuesDeep<Array<Brand>>(actualValues, AttributeIdentifiers.BrandName);
	const generics = getAttributeValuesDeep<Generic>(actualValues, AttributeIdentifiers.GenericName);
	const disease = getAttributeValueDeep<Disease>(actualValues, AttributeIdentifiers.Disease) || null;
	const indication = getAttributeValueDeep<Indication>(actualValues, AttributeIdentifiers.Indication) || null;
	const scopeId = getAttributeValueDeep<string>(actualValues, AttributeIdentifiers.ScopeId) || null;
	const relevantIndication = getAttributeValueDeep<Article71Indication>(actualValues, AttributeIdentifiers.RelevantIndication) || null;

	return {
		multiBrandSets: castToArray<Array<Brand>>(brands).filter(Boolean) || [],
		generics: castToArray<Generic>(generics).filter(Boolean) || [],
		unfilteredBrands: castToArray<Array<Brand>>(brands) || [],
		unfilteredGenerics: castToArray<Generic>(generics) || [],
		disease,
		indication: typeof indication === "string" ? null : indication,
		scopeId,
		relevantIndication,
	};
};
